import React, { PureComponent } from 'react';
import classNames from 'classnames'
import { Link, withRouter } from 'react-router-dom'
import Instances from '../alert/Instances'
import bindAllActions from '../../common/bindAllActions'
import PropTypes from 'prop-types';
import { filter, pipe, sort, groupBy, mapObjIndexed, values, pluck, uniq, find, propEq, path, length } from 'ramda'
import { dateVal, getDeviceSlug, pathsChanged } from '../../common/ambient'
import { rawFeathersRequest } from '../../common/feathers'
import {
  FromNow,
  Loader
 } from '../../components'

/**
 * User must be logged in to mount this component!
 */
class Notifications extends PureComponent {
  static propTypes = {
    socialActions: PropTypes.object

  }
  state = {
    tab: 'notifications',
    notifications: [],
    notificationLoading: false
  }
  constructor(props) {
    super(props)
    this._fetchSocialActivity = ::this._fetchSocialActivity
    this._close = ::this._close
    this.allUserActions = []
  }
  componentDidUpdate(prevProps, prevState) {
    const { device, userActions, user, commonActions } = this.props
    if (pathsChanged(this.props, prevProps, [['common', 'appClass']])) {
      if (this._isOpen()) {
        userActions.patch(user.info._id, { notificationsLastChecked: Date.now() })
        this._fetchSocialActivity()
      }
    }
    if (pathsChanged(this.props, prevProps, [['device', 'appPaused']])) {
      if (device.appPaused) {
        clearTimeout(this._tout)
      } else {
        this._fetchSocialActivity()
      }
    }
  }
  _isOpen() {
    return this.props.common.appClass.includes('notifications-open')
  }
  _close() {
    const { commonActions } = this.props
    commonActions.toggleAppClass('notifications-open', false)
  }
  _fetchSocialActivity(){
    const { alertActions, socialActions, user } = this.props
    const { lastChecked } = this.state
    clearTimeout(this._tout)
    this._tout= setTimeout(this._fetchSocialActivity, 1000 * 60 * 5)
    const aiArgs = {
      userId: path(['info', '_id'], user),
      $sort: { createdAt: -1 }
    }

    // Build query string for new notifications endpoint
    const params = new URLSearchParams({ limit: 500 })
    // Only use 'since' for polling updates, not initial load
    // This allows notifications to stay visible for the backend's default window
    if (lastChecked) {
      params.append('since', new Date(lastChecked).toISOString())
      aiArgs.createdAt = {
        $gt: lastChecked
      }
    } else if (user.info.notificationsLastChecked) {
      const userLastChecked = dateVal(user.info.notificationsLastChecked)
      aiArgs.createdAt = {
        $gt: userLastChecked
      }
    }

    this.setState({
      notificationLoading: true,
      lastChecked: Date.now()
    })
    alertActions.fetchInstances(aiArgs)
    rawFeathersRequest(`/userActions/notifications?${params.toString()}`)
      .then(response => {
        // response = { notifications: [...], meta: {...} }
        const actions = response.notifications || []
        const dateSort = sort((a,b) => dateVal(b.createdAt) - dateVal(a.createdAt))
        if (actions.length < 1) {
          const st8 = {
            notificationLoading: false,
          }
          if (!lastChecked) {
            st8.tab = 'alerts'
          }
          this.setState(st8)
          throw 'skip the rest'
        }
        this.allUserActions = this.allUserActions.concat(actions)
        this.notificationData = pipe(
          groupBy(ua => `${ua.to._id}-${ua.type}-${ua.notificationType}`),
          mapObjIndexed((arr, key) => {
            const parts = key.split('-')
            return {
              key,
              createdAt: dateSort(arr)[0].createdAt, // the most recent userAction
              type: parts[1],
              notificationType: parts[2],
              postId: arr[0].to._id,
              arr
            }
          }),
          values,
          dateSort
        )(this.allUserActions)
        return socialActions.fetchPosts({
          _id: {
            $in: uniq(pluck('postId', this.notificationData))
          }
        })
      })
        .then(posts => {
          const notifications = this.notificationData.map(nd => {
            return Object.assign({
              post: find(propEq('_id', nd.postId), posts.data)
            }, nd)
          }).filter(nd => nd.post)
          const st8 = {
            notificationLoading: false,
            notifications,
          }
          this.setState(st8)
        })
        .catch(e => {
        })
  }
  componentDidMount() {
    this._fetchSocialActivity()
  }
  componentWillUnmount() {
    clearTimeout(this._tout)
  }
  _shouldShowPreview(post) {
    // Skip widget posts that have no text
    if (post.type && /widget/.test(post.type) && !post.text) {
      return false
    }
    // Show preview if there's text or image
    return post.text || post.image
  }
  _getThumbnailUrl(imageUrl) {
    if (!imageUrl) return null
    // Use 100x100 resize instead of 1000x1000 for thumbnails
    return imageUrl.replace(
      'cdn.filestackcontent.com/',
      'd2pr2a8f0ao4pf.cloudfront.net/rotate=deg:exif/cache=expiry:max/resize=width:100,height:100,fit:clip/compress/'
    )
  }
  _tab() {
    const { deviceActions, device, history, user } = this.props
    const { tab, notifications } = this.state
    const currentUserId = user.info._id
    const typeDivs = {
      like: nd => {
        // Filter out the post owner's own likes
        const otherLikes = nd.arr.filter(ua => ua.userId !== currentUserId)
        const count = otherLikes.length

        if (count === 0) return null

        return <div className='like'>
          {count} {count === 1 ? 'person' : 'people'} liked your post.
        </div>
      },
      comment: nd => {
        // Filter out the post owner's own comments
        const otherComments = nd.arr.filter(ua => ua.userId !== currentUserId)

        if (otherComments.length === 0) return null

        const firstUserId = otherComments[0].userId
        const others = pipe(
          pluck('userId'),
          uniq,
          filter(uId => uId !== firstUserId),
          length
        )(otherComments)
        const postText = nd.notificationType === 'ownPost'
          ? 'your post'
          : 'a post you commented on'
        return <div className='comment'>
          {otherComments[0].data.username} {others > 0 ? `and ${others} other${others === 1 ? '' : 's'}` : ''} commented on {postText}.
        </div>
      }
    }
    const ret = []
    if (tab === 'alerts' && this._isOpen()) {
      ret.push(
        <Link key="alerts" onClick={this._close} to="/alerts" className='alerts-tab'><Instances /></Link>
      )
    }
    ret.push(
      <div key={`notifications-${this._isOpen() && 'open'}`} className='notifications-tab'>
        {notifications.map(nd => {
          const content = typeDivs[nd.type](nd)
          // Don't render notification if content is null (all actions were from post owner)
          if (!content) return null

          return <Link onClick={() => {
            this._close()
            history.push(`/social/post/${nd.post._id}`)
          }} key={nd.key} className='notification'>
            <div className='notification-content'>
              {content}
              <FromNow dateutc={nd.createdAt} />
            </div>
            {this._shouldShowPreview(nd.post) && (
              <div className='post-preview'>
                {nd.post.image && (
                  <div
                    className='preview-thumbnail'
                    style={{ backgroundImage: `url(${this._getThumbnailUrl(nd.post.image)})` }}
                  />
                )}
                {nd.post.text && (
                  <div className='preview-text'>
                    {nd.post.text}
                  </div>
                )}
              </div>
            )}
          </Link>
        })}
      </div>
    )
    return ret
  }
  _showBadge() {
    const { user, alert } = this.props
    const { alertInstances } = alert 
    const { tab, notifications, notificationLoading } = this.state
    const  notificationsLastChecked = path(['info', 'notificationsLastChecked'], user)
    if (!notificationsLastChecked && (notifications.length > 0 || alertInstances.length > 0)) {
      return true
    }
    const moreRecentThings = filter(nd => dateVal(nd.createdAt) > dateVal(notificationsLastChecked))
    if (moreRecentThings(notifications).length > 0) {
      return true
    }
    if (moreRecentThings(alertInstances).length > 0) {
      return true
    }
    return false
  }
  render() {
    const { user, alert, commonActions } = this.props
    const { fetchInstancesPending } = alert
    const { tab, notifications, notificationLoading } = this.state
    const  notificationsLastChecked = path(['info', 'notificationsLastChecked'], user)
    const loading = fetchInstancesPending || notificationLoading
    return (
      <div className={classNames('social-notifications', { open: this._isOpen(), active: this._showBadge() })}>
        <a onClick={() => commonActions.toggleAppClass('notifications-open', !this._isOpen())} className='notifications' />
        <div className='notifications-wrap'>
          <div className='top'>
            <div className='pills'>
              <a onClick={() => this.setState({ tab: 'notifications' })} className={classNames('notifications-btn btn btn-circle', { active: tab === 'notifications' })}>Notifications</a>
              <a onClick={() => this.setState({ tab: 'alerts' })} className={classNames('alerts-btn btn btn-circle', { active: tab !== 'notifications' })}>Alerts</a>
            </div>
            <div className='right'>
              {loading && <Loader />}
              <Link onClick={this._close} to="/alerts" className='settings'></Link>
              <a className='close' onClick={this._close}></a>
            </div>
          </div>
          <div className='notifications-list-wrap'>
            <div className={classNames('notifications-list', `tab-${tab}`)}>
              {this._tab()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default bindAllActions(withRouter(Notifications))

Notifications.displayName = 'Notifications'
